import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const StyledMenu = styled.div<{ $fullHeight?: boolean }>`
  height: ${(props) => (props.$fullHeight ? '100%' : 'auto')};
  min-height: ${(props) => (props.$fullHeight ? '100vh' : '0px')};
  position: relative;
  left: 0px;
  top: 0px;
  overflow: hidden auto;
  z-index: 10;
  width: 240px;
  background: ${ThemePrisma.colors.lightblue[7]};
`;

export const AppMenuDivider = styled.li`
  width: 100%;
  height: 1px;
  background: ${ThemePrisma.colors.gray[4]};
  margin: 8px 0px;
`;

export const StyledMenuTitle = styled.li`
  font-family: Inter, sans-serif;
  font-size: 0.75rem;
  letter-spacing: 0em;
  line-height: 1rem;
  font-weight: 600;
  color: ${ThemePrisma.colors.gray[3]};
  padding: 8px 8px 4px;
  box-sizing: border-box;
`;

export const AppMenuItemContainer = styled.div`
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  isolation: isolate;
  width: 100%;
  box-sizing: border-box;
`;

export const ButtonLogo = styled.div`
  cursor: pointer;
`;
